import { useState } from "react";
import { fetchAndParseM3U, type M3UChannel } from "../../adapters/static/m3u";

export interface M3UConnectStepProps {
  onConnected: (channels: M3UChannel[], playlistUrl: string) => void;
}

export function M3UConnectStep({ onConnected }: M3UConnectStepProps) {
  const [url, setUrl] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setError(null);
    setLoading(true);
    try {
      const channels = await fetchAndParseM3U(url);
      if (channels.length === 0) throw new Error("Playlist is empty or invalid");
      onConnected(channels, url);
    } catch (e: unknown) {
      const msg = e instanceof Error ? e.message : "Failed to load M3U";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <h3>Connect M3U Playlist</h3>
      <p>Paste the URL of your M3U or M3U8 playlist.</p>
      <input
        type="url"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        placeholder="http://example.com/playlist.m3u"
        style={{ width: "100%", padding: 8, marginBottom: 12 }}
      />
      <button onClick={handleConnect} disabled={loading || !url}>
        {loading ? "Loading..." : "Connect"}
      </button>
      {error && <div style={{ color: "#c00", marginTop: 12 }}>{error}</div>}
    </div>
  );
}
